"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAvailableWaiveFormulaFieldsProposals = exports.createWaiveConfigEvaluator = exports.checkWaiveConfigErrors = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const waiveConfigFormulaAvailableVariablesConfigs = {
    'loanTapeMetadata.reportingDate': {
        label: 'loanTapeMetadata.reportingDate',
        description: 'Loan tape reporting date (loan tape metadata)',
    },
    'receivables.totalReceivableValuation': {
        label: 'receivables.totalReceivableValuation',
        description: 'Total receivable valuation',
    },
    'receivables.totalEligibleExposure': {
        label: 'receivables.totalEligibleExposure',
        description: 'Total Eligible Exposure',
    },
};
const waiveConfigFormulaAvialableVariables = Object.keys(waiveConfigFormulaAvailableVariablesConfigs);
const checkWaiveConfigErrors = ({ waiveConfigs, }) => {
    const availableVariables = new Set(waiveConfigFormulaAvialableVariables);
    const missingVariablesPerField = waiveConfigs.map((waiveConfig) => {
        const formulaErrors = (0, formula_engine_1.getFormulaErrors)(waiveConfig.config.formula, availableVariables);
        return {
            reason: waiveConfig.reason,
            ...formulaErrors,
        };
    });
    // filter out things that are not really missing.
    const definitelyMissing = missingVariablesPerField.filter(({ missingVariables }) => missingVariables.length > 0);
    return definitelyMissing;
};
exports.checkWaiveConfigErrors = checkWaiveConfigErrors;
const createWaiveConfigEvaluator = (waiveConfigs, f1EngineMode) => {
    // extract formulas from the config.
    // instantiate FormulaEngine with all formula strings
    // we need to do this upfront to ensure that formula's AST are cached.
    const formulaStrings = waiveConfigs.map((config) => {
        (0, common_1.finleyAssert)(config.config.engineVersion ===
            finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${config.config.engineVersion} is not yet supported`);
        return config.config.formula;
    });
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, formulaStrings, f1EngineMode);
    const setVariables = (inputs) => {
        formulaEngine.setVariables(inputs, { flatten: true });
    };
    const evaluate = (inputs) => {
        setVariables(inputs);
        // find 1st waiver that evaluates to true.
        const waivedConfig = waiveConfigs.find((config) => formulaEngine.evaluateBoolean(config.config.formula));
        // if a waiver evaluated to true, find the reason, otherwise null.
        return waivedConfig ? waivedConfig.reason : null;
    };
    return {
        evaluate,
    };
};
exports.createWaiveConfigEvaluator = createWaiveConfigEvaluator;
/**
 * Generates list of helpful fields available to a waive config formula CompletionItems for Monaco Editor
 */
const createAvailableWaiveFormulaFieldsProposals = () => _.map(waiveConfigFormulaAvailableVariablesConfigs, ({ label, description }) => {
    return {
        label,
        documentation: description,
        insertText: label,
    };
});
exports.createAvailableWaiveFormulaFieldsProposals = createAvailableWaiveFormulaFieldsProposals;
//# sourceMappingURL=waiverEvaluator.js.map